<template>
  <div>
    <app-echart-doughnut :series="series" style="width: 100%" />

    <div
      class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1 mt-1"
    >
      <small></small>
      <small class="timeline-item-time text-nowrap text-muted ml-1"
        >Source: Insee</small
      >
    </div>
  </div>
</template>

<script>
import AppEchartDoughnut from "@core/components/charts/echart/AppEchartDoughnut.vue";

export default {
  components: {
    AppEchartDoughnut,
  },
  props: {
    demographyByPeriode: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      series: [
        {
          name: "Logements",
          type: "pie",
          radius: "55%",
          center: ["50%", "50%"],
          animationType: "scale",
          animationEasing: "elasticOut",
          animationDelay: function () {
            return Math.random() * 200;
          },
          avoidLabelOverlap: true,
          tooltip: {
            formatter: "{a} <br/>{b} : {d}%",
          },
          label: {
            show: true,
            formatter: "{name|{b}}\n{percent|{d}%}",
            minMargin: 5,
            fontSize: 14,
            lineHeight: 15,
            rich: {
              percent: {
                fontSize: 14,
                color: "#999",
              },
            },
          },
          labelLine: {
            show: true,
            length: 10,
            length2: 5,
            maxSurfaceAngle: 80,
          },
          data: [
            {
              value:
                this.demographyByPeriode.data[
                  this.demographyByPeriode.data.length - 1
                ].lodgment.division.main_lodgment_rate,
              name: "Résidences pricipales",
            },
            {
              value:
                this.demographyByPeriode.data[
                  this.demographyByPeriode.data.length - 1
                ].lodgment.division.secondary_lodgement_rate,
              name: "Résidences secondaires",
            },
            {
              value:
                this.demographyByPeriode.data[
                  this.demographyByPeriode.data.length - 1
                ].lodgment.division.empty_lodgement_rate,
              name: "Logement vide",
            },
          ].sort(function (a, b) {
            return a.value - b.value;
          }),
        },
      ],
    };
  },
};
</script>
